import { isNumber } from 'lodash';
import React, { memo } from 'react';
import styled from 'styled-components';

interface ICount {
  className?: string;
  value: number;
}

const Count = ({ value, ...props }: ICount) => {
  if (!isNumber(value)) {
    return null;
  }

  return <StyledCount {...props}>{value}</StyledCount>;
};

const StyledCount = styled.div`
  background-color: #f8e71c;
  border-radius: 50%;
  color: #17181a;
  font-size: 12px;
  height: 23px;
  line-height: 23px;
  text-align: center;
  min-width: 23px;
  border-radius: 23px;
  padding: 0 7px;
`;

export default memo(Count);
